namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogDeleteUserSettings extends GContentBase {
        private funkcniMista: string[];
        private osoby: string[];
        private openFromDetail: boolean;
        private rezimDialog: RezimDialog;

        prepareContent() {
            this.init()
        }

        private init() {
            this.title = this.createTitle();
            this.createActions();
            this.createFormEl();
            this.createCommandBar();
        }

        private createTitle(): string {
            switch (this.rezimDialog) {
                case RezimDialog.fukncniMisto:
                    return "jres:33000866"; //RC 33000866 : Smazání uživatelského nastavení osobám navázaným na funkční místa
                default:
                    return "";
            }
        }

        private createActions() {
            this.actions.addRange({
                actOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.actOK();
                    }
                },
                actClose: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.close();
                    }
                }
            })
        }

        private createCommandBar() {
            this.commandBar(this.actions.createBar(["actClose*", "actOk!"]))
        }

        private createFormEl() {
            const form = new Gordic.Forms.Form({
                name: "form-delete-user-settings",
                customClass: "form-delete-user-settings",
                layoutDescriptor: "L1M1S1, L-12-12-0, M-12-12-0, S-12-12-0"
            })
            switch (this.rezimDialog) { 
                case RezimDialog.fukncniMisto:
                    form.addRow(this.openFromDetail == true ? "jres:32131054" : "jres:33000093").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                        name: "ixs_fun",
                        model: "model.ixs_fun=value.ixs_fun;model.ixs_ref<=value.ixs_ref;model.ixs_ref_txt<=value.nazev_ref;model.ixs_fun_txt<=value.nazev",
                        validators: [new Gordic.Validators.Required({
                            stopping: true
                        })],
                        flag: "required",
                        itemWidth: (this.openFromDetail == true) ? undefined : "",
                        multi: (this.openFromDetail == true) ? false : true,
                        dropdown: false,
                        initialValue: (this.openFromDetail == true) ? { ixs_fun: this.funkcniMista[0] } : this.funkcniMista.map((value) => ({ ixs_fun: value })),
                        disabled: this.openFromDetail == true
                    })
                    break;
                case RezimDialog.osoba:
                    form.addRow(this.openFromDetail == true ? "jres:32131110" : "jres:33000092").addField("gselectbox", Gordic.Prefabs.Select.ginsref(), {
                        name: "ixs_ref",
                        model: "model.ixs_ref=value.ixs_ref;model.ixs_ref_txt<=value.nazev_ref",
                        validators: [new Gordic.Validators.Required({
                            stopping: true
                        })],
                        flag: "required",
                        itemWidth: (this.openFromDetail == true) ? undefined : "",
                        multi: (this.openFromDetail == true) ? false : true,
                        dropdown: false,
                        initialValue: (this.openFromDetail == true) ? { ixs_ref: this.osoby[0] } : this.osoby.map((value) => ({ ixs_ref: value })),
                        disabled: this.openFromDetail == true
                    })
            }
            form.addRow().addField("gcheck", { //RC 33000867 : Všechny fáze
                name: "all_faze",
                label: "jres:33000867",
                customClass: "gcheck-switch",
                initialValue: true,
                change: (ev, ctx) => {
                    const field = this.findFields("faze");
                    field.gfield("setValidators", ctx.value == true ? [] : [new Gordic.Validators.Required({ stopping: true })])
                    field.gfield(ctx.value == true ? "disable" : "enable");
                }
            })
                .addRow("jres:33000698").addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {
                    name: "faze",
                    model: "model.faze=value.faze",
                    disabled: true,
                    dropdown: false,
                    multi: true,
                    itemWidth: ""
                })
            $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private actOK() {
            const form = this.findForms("form-delete-user-settings");
            if (form.gform("isValid")) {
                this.dialogs.confirmDangerous("jres:33000257", "jres:33000868").on("yes", () => { //RC 33000868 : Opravdu si přejete smazat uživatelské nastavení vybraným osobám. Tato akce již nejde vrátit, proto zvažte zda ji chcete udělat.
                    const result: any = {};
                    form.findFields().gfield("model", "collect", result);
                    const callObj: { ixs_refs: string[], fazes: string[] } = { ixs_refs: [], fazes: [] }
                    switch (this.rezimDialog) {
                        case RezimDialog.fukncniMisto:
                            callObj.ixs_refs = (this.openFromDetail == true) ? [result.ixs_ref] : result.ixs_ref;
                            break;
                        case RezimDialog.osoba:
                            callObj.ixs_refs = (this.openFromDetail == true) ? [result.ixs_ref] : result.ixs_ref;
                            break;
                    }
                    if (result.all_faze == false) {
                        callObj.fazes = result.faze
                    }
                    this.beginOperation();
                    this.isl.AdmOsoba.deleteAppUserSettingsNew(callObj).get().then((successIxsRef) => {
                        if (this.openFromDetail == true) {
                            this.notification("add", {
                                title: "jres:33000869", //RC 33000869 : Smazání uživatelského nastavení
                                content: "jres:33000875", //RC 33000875 : Smazání uživatelského nastavení proběhlo úspěšně.
                                state: "success",
                                icon: "gi-settings"
                            })
                        } else {
                            const resultstring: string[] = [];
                            successIxsRef.forEach((item) => {
                                const index = result.ixs_ref.indexOf(item);


                                if (this.rezimDialog == RezimDialog.fukncniMisto) {
                                    resultstring.push(`${result.ixs_fun_txt[index]} (${result.ixs_ref_txt[index]})`)
                                }
                            })
                            const errorIxsRef = result.ixs_ref.length - successIxsRef.length;
                            let message = "";
                            if (successIxsRef.length > 0)
                                message = `<b>jres:33000870</b> <br /> ${resultstring.join(', ')}<br /><br />` //RC 33000870 : Úspěšně smazané uživatelské nastavení:
                            if (errorIxsRef > 0)
                                message += `<b>jres:33000871</b> ${errorIxsRef}` //RC 33000871 : Počet neúšpěšně smazaných uživatelských nastavení osob: 
                            this.notification("add", {
                                title: "jres:33000869", //RC 33000869 : Smazání uživatelského nastavení
                                content: message,
                                state: errorIxsRef > 0 ? "info" : "success",
                                icon: "gi-settings"
                            })
                        }
                        this.close()
                    }).catch((ex) => {
                        this.notification("add", {
                            title: "jres:33000869", //RC 33000869 : Smazání uživatelského nastavení
                            content: "jres:33000872", //RC 33000872 : Chyba při mazání uživatelského nastavení
                            state: "error",
                            icon: "gi-settings"
                        })
                    }).always(() => { this.endOperation() })
                })
            }
        }
    }

    export enum RezimDialog {
        fukncniMisto,
        osoba
    }
}